import { Link } from 'react-router-dom'
import PageMasthead from '../../components/PageMasthead'
import WireframeBanner from './WireframeBanner'
import { PageDesignNote } from './designNotes'
import { WIREFRAME_PATHS } from './routes'

interface HubLink {
    screenNumber: string
    title: string
    desc: string
    to: string
}

const SD_LINKS: HubLink[] = [
    { screenNumber: '1', title: 'Classifier configuration', desc: 'All classifiers, usage & draft versions. Create / go live / delete.', to: WIREFRAME_PATHS.library },
    { screenNumber: '2', title: 'Organisations list', desc: 'All organisations — entry point into org config.', to: WIREFRAME_PATHS.orgList },
    { screenNumber: '3', title: 'Org config', desc: 'Details & notes, classifiers, teams, profiles, users — entry point into team & profile config.', to: WIREFRAME_PATHS.orgConfig },
    { screenNumber: '4', title: 'Team config', desc: 'Classifier coverage across the team’s profiles, plus the profile list.', to: WIREFRAME_PATHS.teamConfig },
    { screenNumber: '5', title: 'Profile config', desc: 'Profile-level applications and coverage.', to: WIREFRAME_PATHS.profileConfig }
]

const CLIENT_LINKS: HubLink[] = [
    { screenNumber: '7', title: 'Settings (read-only)', desc: 'Client view — organisation details, classifier configuration, profiles & teams. Read-only; contact support to change.', to: WIREFRAME_PATHS.clientOrg }
]

function HubRow({ link }: { link: HubLink }) {
    return (
        <Link
            to={link.to}
            className="flex items-center gap-3 px-4 py-3 border-t border-gray-100 hover:bg-gray-50 no-underline text-inherit"
        >
            <span className="flex h-7 w-7 flex-none items-center justify-center rounded-md bg-gray-100 text-arwen-600 text-xs font-bold">
                {link.screenNumber}
            </span>
            <span className="flex-1">
                <span className="block font-semibold text-gray-900">{link.title}</span>
                <span className="block text-xs text-gray-400">{link.desc}</span>
            </span>
            <span className="text-gray-300 font-bold" aria-hidden="true">→</span>
        </Link>
    )
}

export default function WireframesHubPage() {
    return (
        <div className="w-full bg-gray-50 min-h-full">
            <WireframeBanner />
            <PageDesignNote type="rationale">
                This hub indexes the proposed admin redesign. Every screen below is a wireframe —
                Classifier configuration and Organisations now also appear directly in the live
                Admin sidebar (shown in red). Use the toggle above to hide these design notes.
            </PageDesignNote>
            <PageMasthead
                title="Wireframes"
                subtitle="Prototype screens for stakeholder review. Not wired to live data."
            />
            <div className="p-6">
                <div className="max-w-3xl rounded-xl border border-gray-200 bg-white overflow-hidden">
                    <div className="flex items-center gap-2 px-4 py-3 border-b border-gray-100">
                        <h2 className="m-0 text-base font-medium text-gray-900">Policy and Configuration wireframes</h2>
                        <span className="ml-auto text-xs text-gray-400">{SD_LINKS.length + CLIENT_LINKS.length} screens</span>
                    </div>
                    <div className="px-4 pt-3 pb-1 bg-gray-50/60 text-[11px] font-bold uppercase tracking-wide text-gray-500">Service Delivery</div>
                    {SD_LINKS.map((l) => <HubRow key={l.screenNumber} link={l} />)}
                    <div className="px-4 pt-3 pb-1 bg-gray-50/60 text-[11px] font-bold uppercase tracking-wide text-gray-500">Client</div>
                    {CLIENT_LINKS.map((l) => <HubRow key={l.screenNumber} link={l} />)}
                </div>
            </div>
        </div>
    )
}
